<script setup lang="ts">
import { computed } from 'vue';
import { DOC_TYPE_LABELS } from '@/constants';

interface Props {
  docType: keyof typeof DOC_TYPE_LABELS;
  number: number;
  variant?: 'white' | 'gray';
}

const props = withDefaults(defineProps<Props>(), { variant: 'white' });

const label = computed(() => DOC_TYPE_LABELS[props.docType]);
</script>

<template>
  <span
    class="citation-pill c-outlineTag c-outlineTag--small c-outlineBtn--secondary c-title-medium--xs"
    :class="`citation-pill--${variant}`"
  >
    {{ label }}<span class="position">{{ number }}</span>
  </span>
</template>

<style scoped lang="scss">
.citation-pill {
  display: inline-flex;
  gap: 2px;
  height: 18px;
  border: none;
  color: $color-gray800;
  cursor: default;

  &--white {
    background-color: $color-white;
  }

  &--gray {
    background-color: $color-gray200;
  }

  .position {
    display: flex;
    flex-shrink: 0;
    justify-content: center;
    align-items: center;
    width: fit-content;
    height: 10px;
    padding: 0 4px;
    border-radius: 5px;
    background-color: $color-gray800;
    color: $color-white;
  }
}
</style>
